import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { useLang } from '../../context/LangContext';
import esTexts from '../../translations/es.json';
import enTexts from '../../translations/en.json';

const AdminNav = () => {
  const { currentUser } = useContext(AuthContext);
  const isAdmin = Boolean(currentUser?.isAdmin);
  const { lang } = useLang();
  const texts = lang === 'es' ? esTexts.admin : enTexts.admin;

  if (!isAdmin) return null;

  const navItems = [
    {
      to: '/admin',
      label: lang === 'es' ? 'Alojamientos' : 'Accommodations',
      icon: 'fa-building-o',
      end: true,
    },
    {
      to: '/admin/universities',
      label: texts.menu_universities || (lang === 'es' ? 'Universidades' : 'Universities'),
      icon: 'fa-university',
    },
    {
      to: '/admin/countries',
      label: texts.menu_countries || (lang === 'es' ? 'Países' : 'Countries'),
      icon: 'fa-globe',
    },
    {
      to: '/admin/destinations',
      label: texts.menu_destinations || (lang === 'es' ? 'Destinos' : 'Destinations'),
      icon: 'fa-map-marker',
    },
    {
      to: '/admin/users',
      label: texts.menu_users || (lang === 'es' ? 'Usuarios' : 'Users'),
      icon: 'fa-users',
    },
    {
      to: '/admin/leads',
      label: texts.menu_leads || 'Leads (OTP)',
      icon: 'fa-whatsapp',
    },
    {
      to: '/admin/logos',
      label: texts.menu_logos || 'Logos',
      icon: 'fa-picture-o',
    },
  ];

  return (
    <div className="admin-nav-container mb-4">
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 bg-white border border-light-subtle rounded-3 p-2 shadow-xs">
        {/* Main Navigation Items with horizontal scroll support */}
        <div className="d-flex align-items-center gap-1 overflow-x-auto admin-nav-scroll py-1 flex-grow-1">
          {navItems.map(item => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => `admin-nav-item ${isActive ? 'active' : ''}`}
            >
              <i className={`fa ${item.icon}`}></i>
              <span>{item.label}</span>
            </NavLink>
          ))}
        </div>

        {/* Action Button: Nueva Propiedad */}
        <div className="flex-shrink-0 ms-auto">
          <NavLink to="/admin/new-accommodation" className="admin-nav-action-btn">
            <i className="fa fa-plus"></i>
            <span>
              {texts.btn_new || (lang === 'es' ? 'Nueva Propiedad' : 'New Accommodation')}
            </span>
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default AdminNav;
